import { Component } from '../component/component';

export class CartItem extends Component {

	constructor(parent) {
		super();
		this.node = this.getNode();
		this.parent = parent;
		this.quantityWrap = this.node.querySelector('.quantity');
		this.quantityPrice = this.quantityWrap.querySelector('.quantity__price');
		this.quantityNumber = this.quantityWrap.querySelector('.quantity__number');
		this.priceWrap = this.node.querySelector('.price');
		this.select = parent.querySelector('select');
		this.hiddenInput = parent.querySelector('#configurationId');
		this.updateQnt();
		this.addListeners();
	}

	getTemplate() {
		let template;
		template = `
			<div class="cart-item">
				<!--<h3 class="h3">${productSheet.titleDoc}</h3>-->
                <div class="price"></div>
                <div class="quantity">
                    <span class="quantity__number"></span>
                    <div class="quantity__price"></div>
                </div>
			</div>
        `;
		return template;
	}

	setPriceByCode(code) {
		if (this.hiddenInput) {
			this.hiddenInput.setAttribute('value', code);
			const event = new Event('onConfigDidChange');
			event.code = code;
			window.dispatchEvent(event);
		}
		const c = (productSheet.typeDB === 'divcal' || productSheet.typeDB === 'divd3') ? /_(.+)/.exec(code)[1] : code.split('_')[1];
		const url = `/api/configurator/products/discountedprice/${productSheet.idDoc}/${c}/${ecommerce.language}/${ecommerce.market}?state=true`;
		fetch(url)
			.then(r => r.json())
			.then(result => {
				this.price = result.price;
				this.currency = result.currency;
				this.promoPrice = result.promoPrice;
				this.isUk = this.currency === '£';
				this.isUsa = this.currency === '$';
				this.updateQnt();
				this.updatePrice();

				const event = new Event('onPriceUpdate');
                event.quantity = this.quantity;
				event.code = code;
                event.listingPrice = this.price;
                event.promoPrice = this.promoPrice;
				event.price = this.promoPrice !== 0 ? this.promoPrice : result.price;
				window.dispatchEvent(event);
			})
			.catch(error => {
				console.log('setPriceByCode', error);
			});
	}

	updatePrice() {
		const price = this.format(this.price);
		const quantityPrice = this.format(this.price * this.quantity);
		let promo = this.promoPrice !== 0 ? this.format(this.promoPrice) : '';
		const quantityPromo = this.getPromo();
		this.quantityNumber.textContent = `${this.quantity} x`;
		this.quantityPrice.innerHTML = `${this.currency} <span>${price}</span> ${promo}`;
		this.priceWrap.innerHTML = `${this.currency} <span>${quantityPrice}</span> ${quantityPromo}`;
		if (this.price === 0) {
			this.parent.classList.add('hidden');
		} else {
			this.parent.classList.remove('hidden');
		}
		this.updateScalaPay((this.promoPrice || this.price) * this.quantity);
	}

	updateScalaPay(price) {
		let scalaPay = this.node.querySelector('scalapay-widget');
		if (scalaPay != null) {
			scalaPay.parentNode.removeChild(scalaPay);
		}
		if (ecommerce.showScalaPay) {
			scalaPay = document.createElement('div');
			scalaPay.innerHTML = `
			<scalapay-widget
				min="5"
				max="${ecommerce.scalaPayMaxValue}"
				amount="${price}"
				size="100px"
				logoSize="100%"
				priceColor="#145ad1"
				logoColor="#000000"
				logoAlignment=""
				numberOfPayments="3"
				hideLogo="false"
				hidePrice="false"
				locale="${ecommerce.language}"
			>
			</scalapay-widget>`;
			this.node.appendChild(scalaPay.firstElementChild);
		}
	}

	updateQnt() {
		if (this.select && this.select.selectedIndex > -1) {
			this.quantity = this.select.options[this.select.selectedIndex].getAttribute('value');
		} else {
			this.quantityWrap.style.display = 'none';
			this.quantityNumber.style.display = 'none';
			this.quantity = 1;
		}
	}

	getPromo() {
		let quantityPromo;
		if (this.promoPrice) {
			this.node.classList.add('cart-item--promo');
			quantityPromo = this.format(this.promoPrice * this.quantity);
		} else {
			this.node.classList.remove('cart-item--promo');
		}
		if (quantityPromo) {
			return quantityPromo;
		}
		return '';
	}

	format(price) {
		if (!price)
			return '0';
		if (this.isUk || this.isUsa) {
			return price.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		}
		return price.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
	}

	onClick(event) {
		this.quantity = event.target.value;
		this.updatePrice();
	}

	addListeners() {
		this.onClick = this.onClick.bind(this);
		if (this.select) {
			this.select.addEventListener('change', this.onClick);
		}
	}

	removeListeners() {
		if (this.select) {
			this.select.removeEventListener('change', this.onClick);
		}
	}

	destroy() {
		this.removeListeners();
	}

}
